/*
 * lostEproDevicePopupController
 * */
/* eslint-disable no-underscore-dangle */
class lostEproDevicePopupController {
	constructor($timeout, iSpiroService, loadingIndicatorService,
		signatureService, appI18n, appConfig, $stateParams, $q,
		ertBasePopupService, notificationService, userService, eproService) {
		'ngInject';
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.iSpiroService = iSpiroService;
		this.loadingIndicatorService = loadingIndicatorService;
		this.signatureService = signatureService;
		this.ertBasePopupService = ertBasePopupService;
		this.notificationService = notificationService;
		this.userService = userService;
		this.eproService = eproService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.$q = $q;
		this.onlineHelpId = 'MSP3.ClinicalData.ISpiro.lostEproDevice';

		this.isLoading = false;
		this.$API = null;
		this.iSpiroForm = null;
		this.state = null;
		this.hasDOB = false;
		this.dobIsInFutureMsg = null;
		this.isFormValid = false;
		this.formData = null;
		this.subjectDemographics = null;
		this.additionalAttributes = null;
		this.studyContext = null;
		this.siteId = null;
		this.technicalSubjectId = null;
		this.subjectId = null;
		this.cancelBtn = null;
		this.isEdit = false;
		this.heading = 'Dispense Device';
		this.lostHeadingId = 'clinicaldata.subject.epro.lostDeviceHeading';
		this.displaySiteNames = [];
		this.displaySubjectKeys = [];
		this.provisionedAppId = null;
		this.deviceActionWidgetEl = null;
		this.protocolSetupLabels = [];
		this.lostInfoText = appI18n.translateImmediate('clinicaldata.subject.epro.lostText');


		this.errors = {
			genericError: false
		};

		// ACTION BUTTONS
		this.submitBtn = {
			action: () => {
				this.lost();
				this.clearActions();
			},
			cssClass: '-es-primary',
			displayName: 'app.buttons.submit',
			isDisabled: false,
			type: 'submit'
		};
		this.cancelBtn = {
			action: () => {
				this.cancelAction();
			},
			displayName: 'app.buttons.cancel',
			isDisabled: false
		};

		this.isEditBlocked = false;
	}

	$onInit() {

		this.configure();
		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		this.eproService.getProtocolSetupLabels().then((response) => {
			const rawLabels = response.data;
			this.protocolSetupLabels = [
				rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
				rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
			].filter(Boolean);
		});

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					this.state = state;
				}
			}
		}
	}
	clearActions() {
		this.actions = [];
	}
	lostDevice(data) {
		const provisonedAppData = data.find(d => d.context.appId === this.provisionedAppId);
		const lostDevicePayload = {
			context: {
			  subjectContext: provisonedAppData.context.subjectContext,
			  participantId: '',
			  appId: provisonedAppData.context.appId,
			},
			type: 'AppChangeProvisioningStatus',
			data: {
				provisioningStatus: 'FORCED_DEPROVISIONED'
			}
		  };
		  this.loadingIndicatorService.show();
		  this.eproService.lostDevice(provisonedAppData.context.appId, lostDevicePayload, this.siteId).then((response) => {
			this.open = false;
			this.notificationService.showSuccess(
				this.appI18n.translateImmediate('clinicaldata.subject.epro.lostDeviceSuccess')
			);
			this.loadingIndicatorService.hide();
		  }).catch(() => {
			this.loadingIndicatorService.hide();
		  });
	}
	showSuccessMessage() {
		const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
		placeholderEl.empty().append('<h4>Subject data is updated.</h4>');
		this.loadingIndicatorService.hide();
	}

	lost() {
		this.loadingIndicatorService.show();
		this.eproService.closeDeviceInit(this.technicalSubjectId).then((response) => {
			this.lostDevice(response.data);
		}).catch(() => {
			this.loadingIndicatorService.hide();
		});
	}

	configure() {
		this.popupHeading = 'clinicaldata.subject.i-spiro.lost-dispense.dispenseTitle';
	}


	setApi() {
		const $API = {
			open: (isRemoteAction, countryId, siteId, technicalSubjectId, displaySiteName, subjectKey, subjectId) => {
				this.loadingIndicatorService.show();
				this.heading = this.lostHeadingId;
				this.siteId = siteId;
				this.technicalSubjectId = technicalSubjectId;

				this.actions = [this.submitBtn, this.cancelBtn];
				this.open = true;

				const provisionedAppIdsPromise = this.eproService.getProvisionedAppIds(siteId, technicalSubjectId);

				provisionedAppIdsPromise.then((response) => {
					if (response.data.length === 1) {
						this.provisionedAppId = response.data[0];
						this.$timeout(() => {
							const placeholderEl = angular.element(document).find('#lost-placeholder');
							this.deviceActionWidgetEl = angular.element('<device-action-close  />');

							this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
								const formData = event.detail;
								this.formData = formData;
							});

							this.deviceActionWidgetEl[0].addEventListener('formValidationChange', (event) => {
								const isFormValid = event.detail;
								this.isFormValid = isFormValid;
							});

							this.deviceActionWidgetEl[0].siteIds = [displaySiteName];
							this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
							this.deviceActionWidgetEl[0].showInfoBox = false;
							this.deviceActionWidgetEl[0].showClosingSpinner = false;
							this.deviceActionWidgetEl[0].infoText = this.lostInfoText;
							this.displaySiteNames = [displaySiteName];
							this.displaySubjectKeys = [subjectKey];
							this.deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
							placeholderEl.empty().append(this.deviceActionWidgetEl);
							this.loadingIndicatorService.hide();
						}, 200);
					}
				}).catch(() => {
					this.loadingIndicatorService.hide();
					this.notificationService.error('Error loading data');
				});
				
			},
			lost: () => {
				this.open = false;
			}
		};
		return $API;
	}

	cancelAction() {
		this.$API.lost();
	}

	getSignatureType() {
		return this.appConfig.sigType.noSignature;
	}

}
/* eslint-enable no-underscore-dangle */
export default lostEproDevicePopupController;
